module.exports = __webpack_public_path__ + "img/partner_logo02.4f13dfdc.png";